import { defineStore } from 'pinia'

interface State {
  vatPercentage: string | null,
}

export const useAppStore = defineStore('App', {
  state: (): State => ({
    vatPercentage: null,
  }),
  getters: {
    getVat: (state: State) => {
      return state.vatPercentage ? parseFloat(state.vatPercentage) : 0
    },
  },
  actions: {
    setVatPercentage (percentage: string) {
      this.vatPercentage = percentage
    },
  },
})
